<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="">
        <v-flex xs12>
          <h3 class="text-center">View Request</h3>
        </v-flex>
        <v-flex xs12 md6 sm5 class="pa-1">
          <v-card>
            <v-card-title>
              <v-spacer></v-spacer>
              Details
            </v-card-title>
            <v-card-text>
              <my-details :detail="['Location', service_request.location]"></my-details>
              <my-details :detail="['Client Name', service_request.client ? service_request.client.name : '']"></my-details>
              <my-details :detail="['Age Group', service_request.client ? service_request.client.age_group : '']"></my-details>
              <my-details :detail="['Contact', service_request.client ? service_request.client.phone : '']" v-show="$admin || unpaidInvoices.length == 0"></my-details>
              <my-details :detail="['Phone', service_request.phone]" v-show="$admin || unpaidInvoices.length == 0"></my-details>
              <my-details :detail="['Time', moment(service_request.created_at).format('dddd MMMM D, yyyy H:m')]"></my-details>
              <my-details :detail="['Note', service_request.note]"></my-details>
              <my-details header="Cost" v-if="$admin">
                <span class="receipt">{{ service_request.cost ? service_request.cost.format(2) : '' }}</span>
              </my-details>
              <!-- <my-details v-if="$admin" :detail="['Cost', service_request.cost]"></my-details> -->
              <my-details :detail="['Type', service_request.type]"></my-details>
              <my-details :detail="['Insurance?', service_request.insurance_provider ? service_request.insurance_provider.name : '']"></my-details>
              <a download :href="'/' + service_request.file" v-show="service_request.file">Attached File</a>
              <my-details header="Package">
                <div class="flex" v-if="service_request.package">
                  <p v-html="service_request.package.name" class="mb-0"></p>
                  <p v-html="service_request.package.description" class="mb-0"></p>
                </div>
              </my-details>
              <p v-if="service_request.details">
                <my-details v-for="(detail, title) in service_request.details" :key="title.toString() + Math.random()" :header="title.toTitleCase()">
                  <p class="my-0" v-for="det, index in detail" :key="index" v-text="det"></p>
                </my-details>
              </p>
              <p>
                <b>Professional</b>
                <inertia-link v-if="service_request.professional_id" :href="'/professionals/' + service_request.professional_id">{{ service_request.professional ? service_request.professional.name : '(Not Found)' }}</inertia-link>
                <em v-else>Unclaimed</em>
              </p>
              <p v-if="service_request.visit_id">
                <inertia-link title="View visit details and add additional invoice(s)" :href="'/clients/' + service_request.client_id + '/visits/' + service_request.visit_id">View Visit Details <v-icon color="green darken-2">mdi-cash</v-icon></inertia-link>
              </p>
              <p v-if="service_request.requestable_type == 'App\\Models\\Visit'">
                <inertia-link title="View claim details and add additional invoice(s)" :href="'/clients/' + service_request.client_id + '/visits/' + service_request.requestable_id">View Claim <v-icon color="green darken-2">mdi-cash</v-icon></inertia-link>
              </p>
              <p v-if="service_request.requestable_type == 'App\\Models\\PatientTest'">
                <inertia-link title="View lab tests and add additional invoice(s)" :href="'/patient_tests/' + service_request.requestable_id">View Request <v-icon color="green darken-2">mdi-cash</v-icon></inertia-link>
              </p>
              <p v-if="service_request.requestable_type == 'App\\Models\\PharmacyRequest'">
                <inertia-link title="View pharmacy details and add additional invoice(s)" :href="'/pharmacy_requests/' + service_request.requestable_id">View Request <v-icon color="green darken-2">mdi-cash</v-icon></inertia-link>
              </p>
              <p v-if="service_request.requestable_type == 'App\\Models\\TikoRequest'">
                <inertia-link title="View TIKO request and add additional invoice(s)" :href="'/tiko_requests/' + service_request.requestable_id">View Request <v-icon color="green darken-2">mdi-cash</v-icon></inertia-link>
              </p>
              <p v-if="service_request.requestable_type == 'App\\Models\\HomeBasedCare'">
                <inertia-link title="View home-based care and add additional invoice(s)" :href="'/home-based-care/' + service_request.requestable_id">View Request <v-icon color="green darken-2">mdi-cash</v-icon></inertia-link>
              </p>
              <br>
              <service-request-confirmation :service_request="service_request" :errors="errors"></service-request-confirmation>
            </v-card-text>
            <v-sheet v-show="canTransfer">
              <v-divider></v-divider>
              <v-autocomplete :items="professionals" item-text="name" item-value="id" no-data-text="Write a name to search ..." no-filter label="Assign to Professional" dense hint="Write a name to search ..." v-model="transfer.professional_id" :search-input.sync="transfer.professional_name" :loading="searching" clearable :disabled="unpaidInvoices.length > 0"></v-autocomplete>
              <confirm-password @confirmed="initTransfer(transfer)" :disabled="!transfer.professional_id" v-if="unpaidInvoices.length < 1">
                <v-btn small :disabled="!transfer.professional_id" color="primary" class="pull-right" :loading="transfering">Save</v-btn>
              </confirm-password>
              <v-btn small disabled color="primary" class="pull-right" :loading="transfering" v-else>Save</v-btn>
              <br>
              <v-divider></v-divider>
            </v-sheet>
            <v-sheet v-if="unpaidInvoices.length > 0">
              <p class="my-0 text-danger">There's an unpaid invoice for this service requests.</p>
            </v-sheet>
            <v-card-actions class="py-0 my-0" v-show="unpaidInvoices.length === 0 || $admin">
              <confirm-password @confirmed="claimReq(service_request)" :disabled="unpaidInvoices.length > 0">
                <v-btn small title="Claim this request" color="green" :disabled="unpaidInvoices.length > 0" v-if="!service_request.professional_id">
                  Claim
                </v-btn>
              </confirm-password>
              <confirm-password @confirmed="unclaimReq(service_request)" :disabled="unpaidInvoices.length > 0">
                <v-btn small title="Unclaim this request" color="red" :disabled="unpaidInvoices.length > 0" v-if="service_request.unclaim">
                  Unclaim
                </v-btn>
              </confirm-password>
              <v-spacer></v-spacer>
              <v-btn small @click="getDirection" title="Get Directions" v-show="unpaidInvoices.length < 1">
                Get Directions
                <v-icon right>mdi-map-marker-distance</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 md6 sm7 id="map" class="pa-1">
          <v-card>
            <v-card-text>
              <geolocation-component :longitude="service_request.longitude" :latitude="service_request.latitude"></geolocation-component>
              <!-- <gmap-map :center="mycoordinates" :zoom="zoom" style="width: 100%; height: 74vh;">
                <gmap-marker
                  :key="index"
                  label="★"
                  title="Request's Location"
                  v-for="(m, index) in markers"
                  :position="m.position"
                  :clickable="true"
                  :draggable="false"
                  @click="center=m.position"
                  :animation="4"
                />
              </gmap-map> -->
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const ConfirmPassword = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/ConfirmsPassword')
  const MyDetails = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/details')
  const GeolocationComponent =  async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "geolocation" */ '@/Components/components/geolocation')
  const ServiceRequestConfirmation = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "service-requests" */ '@/Components/ServiceRequest/components/confirmation')

  export default {
    name: 'ViewRequest',
    layout,
    props: [
      'service_request',
      'canTransfer',
      'errors'
    ],
    components: {
      MyDetails,
      ConfirmPassword,
      GeolocationComponent,
      ServiceRequestConfirmation,
    },
    metaInfo () {
      return {
        title: 'View Request',
        titleTemplate: '%s | ' + this.$title
      }
    },
    data () {
      return {
        zoom: 6,
        origin: {},
        base: 'https://www.google.com/maps/dir/?api=1',
        professionals: [],
        transfer: {
          professional_id: '',
          professional_name: ''
        },
        searching: false,
        transfering: false,
      }
    },
    methods: {
      getCordinates () {
        var options = {
          enableHighAccuracy: true, //defaults to false
          timeout: Infinity, //defaults to Infinity
          maximumAge: 0 //defaults to 0
        }
        this.$getLocation(options)
        .then(coordinates => {
          this.origin = coordinates
          this.zoom = 11
        })
        .catch(error => {
          swal(error, 'Location access is needed for this page to work', 'error')
        })
      },
      getDirection () {
        // this.getCordinates()
        let $vm = this
        setTimeout(() => {
          let base = $vm.base
          // let origin = $vm.origin.lat + ',' + $vm.origin.lng
          let destination = $vm.service_request.latitude + ',' + $vm.service_request.longitude
          // var url = base + '&origin=' + origin + '&destination=' + destination
          var url = base + '&destination=' + destination

          window.open(url, '_blank')
        }, 2000);
      },
      claimReq (request) {
        if (this.unpaidInvoices.length > 0) {
          swal('There is (an) unpaid invoice(s) for this service request');
          return;
        }
        swal({
          title: 'Claim Request?',
          text: 'You agree to provide the services as requested by the patient?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'red',
          confirmButtonText:'Claim',
        },
        function () {
          this.$inertia.post('/service_requests/' + request.id + '/claim', {
            preserveScroll: false,
            onSuccess: () => {
              swal({ title: 'Claim successfully', type: 'success', timer: 10000 })
            },
          })
        }.bind(this))
      },
      unclaimReq (request) {
        if (this.unpaidInvoices.length > 0) {
          swal('There is (an) unpaid invoice(s) for this service request');
          return;
        }
        swal({
          title: 'Unclaim Request?',
          text: 'The request need to have been claimed recently',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'red',
          confirmButtonText:'Unclaim',
        },
        function () {
          this.$inertia.post('/service_requests/' + request.id + '/unclaim', {
            preserveScroll: false,
            onSuccess: () => {
              swal({ title: 'Unclaim successful!', type: 'success', timer: 10000 })
            },
          })
        }.bind(this))
      },
      searchProfessional () {
        this.searching = true
        axios.get('/professionals?search=' + this.transfer.professional_name)
        .then(res => {
          this.professionals = res.data
          this.searching = false
        })
        .catch(err => {
          this.searching = false
        })
      },
      initTransfer (transfer) {
        swal({
          title: '',
          text: 'Assign to a new professional?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'red',
          confirmButtonText:'Transfer',
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
        },
        function () {
          this.transfering = true
          this.$inertia.post('/service_requests/' + this.service_request.id + '/transfer', { professional_id: transfer.professional_id }, {
            onFinish: () => {
              this.transfering = false
              swal.close()
            }
          })
        }.bind(this))
      }
    },
    mounted () {
      this.$nextTick(() => {
        // this.getCordinates()
      })
    },
    computed: {
      mycoordinates () {
        return {
          lat: this.service_request.latitude,
          lng: this.service_request.longitude
        }
      },
      markers () {
        if (!this.mycoordinates.lat || !this.mycoordinates.lng) {
          return []
        }
        return [
          {
            position: {
              lat: this.mycoordinates.lat,
              lng: this.mycoordinates.lng
            }
          },
          {
            position: {
              lat: this.origin.lat,
              lng: this.origin.lng
            }
          }
        ]
      },
      unpaidInvoices () {
        return this.service_request.invoices
      }
    },
    watch: {
      'transfer.professional_name': _.debounce(function (val) {
        if (val) {
          this.searchProfessional()
        }
      }, 1500)
    }
  }
</script>
